import React from 'react';
import { NavLink, Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { APP_VERSION } from '../../utils/constants';
import './AdminLayout.css';

const AdminLayout = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const getCurrentPage = () => {
        const item = navItems.find(item =>
            item.end ? location.pathname === item.path : location.pathname.startsWith(item.path)
        );
        return item ? item.label : 'Dashboard';
    };

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const navItems = [
        { path: '/admin', label: 'Admin HQ', icon: '📊', end: true },
        { path: '/admin/users', label: 'Users', icon: '👥' },
        { path: '/admin/franchises', label: 'Franchises', icon: '🏪' },
        { path: '/admin/qrcodes', label: 'Tag Management', icon: '🏷️' },
        { path: '/admin/tag-scan', label: 'Scan tag (ID)', icon: '📷' },
        { path: '/admin/orders', label: 'Orders', icon: '📦' },
        { path: '/admin/transactions', label: 'Transactions', icon: '💳' },
        { path: '/profile', label: 'My Profile', icon: '👤' },
        { path: '/admin/settings', label: 'Settings', icon: '⚙️' },
    ];

    return (
        <div className="admin-layout">
            <aside className="admin-sidebar">
                <div className="sidebar-header">
                    <div className="admin-logo">
                        <div className="logo-text-v2">
                            <span className="logo-part-nah">NAH</span>
                            <span className="logo-part-44">44</span>
                        </div>
                        <span className="admin-badge">HQ</span>
                    </div>
                </div>

                <nav className="sidebar-nav">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            end={item.end}
                            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                        >
                            <span className="item-icon">{item.icon}</span>
                            <span className="item-label">{item.label}</span>
                        </NavLink>
                    ))}
                </nav>

                <div className="sidebar-footer">
                    <button className="logout-btn" onClick={handleLogout}>
                        <span className="item-icon">🚪</span>
                        <span className="item-label">Logout</span>
                    </button>
                    <div className="version-info" style={{
                        textAlign: 'center',
                        fontSize: '0.7rem',
                        color: 'var(--text-secondary)',
                        opacity: 0.6,
                        marginTop: '0.75rem',
                        padding: '0.5rem'
                    }}>
                        v{APP_VERSION}
                    </div>
                </div>
            </aside>

            <main className="admin-main">
                <header className="admin-top-bar">
                    <div className="breadcrumb">
                        <span>Admin</span> / <span className="current-page">{getCurrentPage()}</span>
                    </div>
                    <Link to="/profile" className="admin-profile" style={{ textDecoration: 'none' }}>
                        <div className="profile-info">
                            <span className="profile-name">{user?.name || 'Administrator'}</span>
                            <span className="profile-role">{user?.role?.toUpperCase() || 'Super Admin'}</span>
                        </div>
                        <div className="profile-avatar">
                            {user?.name?.charAt(0).toUpperCase() || 'A'}
                        </div>
                    </Link>
                </header>

                <div className="admin-content">
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default AdminLayout;
